import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { styled } from '@mui/material';
import { WhatsApp } from '@mui/icons-material';
import workerImg from '../../media/worker.png';
import { TransitionProps } from '@mui/material/transitions';
import useTranslations from './translation/hooks/translation';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiPaper-root': {
    backgroundColor: '#3a3a3a69',
    border: '1px solid #c8c8c852',
    borderRadius: theme.spacing(0.5),
    backdropFilter: 'blur(15px)', // Add blur effect
    WebkitBackdropFilter: 'blur(15px)', // Add blur effect for Safari
    color: '#FFF',
    paddingBottom: theme.spacing(2),
  },
  '& .MuiDialogTitle-root': {
    fontWeight: 300,
    color: '#FFF',
  },
  '& .MuiDialogContentText-root': {
    fontWeight: 300,
    color: '#FFF',
  },
}));

interface Props {
  percentAmount: string;
}

export const JobModal: React.FC<Props> = ({ percentAmount }) => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const { currentLanguage } = useTranslations();

  const title = currentLanguage === 'pl' ? 'Jesteś zainteresowany współpracą z nami?' : 'Are you interested in working with us?';
  const desc = currentLanguage === 'pl' ? 'Możesz to zrobić, kontaktuj się z nami.' : 'You can do it, contact us.';
  const button = currentLanguage === 'pl' ? 'Kontaktuj się z nami!' : 'Contact us!';

  return (
    <div>
      <div style={{ position: 'relative', paddingTop: percentAmount, margin: '16px', cursor: 'pointer' }} onClick={handleOpen}>
        <img style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'scale-down' }} src={workerImg} alt="Job opportunity" />
      </div>
      <StyledDialog
        open={open}
        TransitionComponent={Transition}
        hideBackdrop
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">{desc}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{ fontWeight: 400, textTransform: 'none', mx: 1.5 }}
            size="large"
            variant="contained"
            fullWidth
            startIcon={<WhatsApp sx={{ color: '#24d366' }} />}
            onClick={() => window.open('https://wa.me/+48729883891')}
          >
            {button}
          </Button>
        </DialogActions>
      </StyledDialog>
    </div>
  );
};
